var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "./Pollyfills.ts";
import { Vue, Component, Prop } from "vue-property-decorator";
import PageHeader from "./PageHeader.vue";
import PageFooter from "./PageFooter.vue";
import "bootstrap";
import * as moment from "moment";
import { AppInsights } from "applicationinsights-js";
window.$bus = new Vue({});
AppInsights.downloadAndSetup({ instrumentationKey: window.config.appInsights.instrumentationKey });
AppInsights.trackPageView();
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loggingUserId = "";
        return _this;
    }
    Object.defineProperty(App.prototype, "lastUpdatedDate", {
        get: function () { return this.lastUpdated ? moment(this.lastUpdated) : null; },
        enumerable: true,
        configurable: true
    });
    App.prototype.mounted = function () {
        var _this = this;
        if (this.userId) {
            AppInsights.setAuthenticatedUserContext(this.userId, this.userEmail);
        }
        AppInsights.flush();
        var token = setInterval(function () {
            if (!AppInsights.context)
                return;
            clearInterval(token);
            _this.loggingUserId = AppInsights.context.user.id;
        }, 1000);
        window.addEventListener("unhandledrejection", function (ev) { return _this.logError(ev.reason); });
    };
    App.prototype.logError = function (err) {
        if (!(err instanceof Error)) {
            err = new Error(err);
        }
        AppInsights.trackException(err);
    };
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "homeUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "homeTitle", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "logoUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "externalLoginUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "loginUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "resetPasswordUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "profileUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], App.prototype, "logoutUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], App.prototype, "showLogin", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "userName", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "userId", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "userEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "userAvatarUrl", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], App.prototype, "pages", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "footerText", void 0);
    __decorate([
        Prop({ type: String })
    ], App.prototype, "lastUpdated", void 0);
    __decorate([
        Prop({ type: String, default: "dddd, LL LT" })
    ], App.prototype, "lastUpdatedFormat", void 0);
    App = __decorate([
        Component({
            name: "App",
            components: {
                PageHeader: PageHeader,
                PageFooter: PageFooter
            }
        })
    ], App);
    return App;
}(Vue));
export default App;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App/App.vue
// module id = 664
// module chunks = 24